/* eslint-disable */
import { StyleSheet } from 'react-native'
import {Dimensions} from 'react-native'
export default StyleSheet.create({
  container: {
    width: Dimensions.get('window').width,
    flexDirection: 'row',
    height  : 44,
    backgroundColor: `#FFFFFF`,
    // alignItems: 'center',
    // justifyContent: 'flex-start', // space-between, space-around
    borderColor: 'grey'

  },
 
  image: {
    width: 20,
    height: 20
  }
})
